<template>
    <app-layout>
        <template #header>
            <div class="flex flex-row justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <em class="fas fa-credit-card"></em> Cartão
                </h2>
                <balance :short=true />
            </div>
        </template>
        <div class="py-12 pt-20 pb-6">
            <flash :timeout="5000"/>
            <div
                class="max-w-3xl mx-auto sm:px-6 lg:px-8"
            >
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg py-8 px-6 flex flex-col space-y-4">
                    <div class="text-lg">
                        <em
                            class="fas fa-arrow-left cursor-pointer"
                            @click="returnToIndex"
                        ></em> {{ update ? 'Redefinir senha do cartão' : 'Criando senha do cartão' }}
                    </div>
                    <div class="text-sm text-gray-600" v-if="!update">
                        Agora que seu cartão chegou certinho, vamos realizar a configuração da senha de 4 dígitos
                        que será utilizada para confirmar os pagamentos realizados com ele, lembrando que esta senha deve ser
                        guardada em segurança para evitar o seu esquecimento.
                    </div>
                    <div class="text-sm text-gray-600" v-else>
                        Preencha os campos para redefinir a senha do cartão.
                    </div>
                    <div v-if="update">
                        <jet-label for="amount" value="Senha Antiga" class="text-sm"/>
                        <jet-input
                            id="amount" class="mt-1 w-full block"
                            type="password" v-model="form.old_password"
                            :placeholder="'Digite a senha antiga'"
                            :maxlength="4"
                        />
                        <jet-input-error :message="form.error('password')" />
                    </div>
                    <div>
                        <jet-label for="amount" value="Senha" class="text-sm"/>
                        <jet-input
                            id="amount" class="mt-1 w-full block"
                            type="password" v-model="form.password"
                            :placeholder="(update ? 'Digite uma nova senha' : 'Digite uma senha')"
                            :maxlength="4"
                            @change.native="validatePassword"
                        />
                        <jet-input-error :message="form.error('password')" />
                    </div>
                    <div>
                        <jet-label for="amount" value="Confirmar senha" class="text-sm"/>
                        <jet-input
                            id="amount" class="mt-1 w-full block"
                            type="password" v-model="form.password_confirmation"
                            :placeholder="'Confirme a senha já digitada'"
                            :maxlength="4"
                            @change.native="validatePassword"
                        />
                        <jet-input-error :message="form.error('password_confirmation')" />
                    </div>
                    <div class="grid grid-cols-5 justify-between gap-8">
                        <div class="col-span-3 flex flex-col space-y-3">
                            <div>A senha deve respeitar as seguintes regras:</div>
                            <div
                                class="rounded-full py-2 px-4 text-sm bg-gray-100 text-gray-500"
                                :class="(passwordErrors.four_digits === -1) ? 'bg-red-100 text-red-500'
                                : (passwordErrors.four_digits === 1) ? 'bg-green-100 text-green-600' : ''"
                            >
                                <em
                                    class="fas fa-ban"
                                    :class="(passwordErrors.four_digits === -1) ? 'fas fa-times'
                                    : (passwordErrors.four_digits === 1) ? 'fas fa-check' : ''"
                                ></em> Deve conter 4 dígitos.
                            </div>
                            <div
                                class="rounded-full py-2 px-4 text-sm bg-gray-100 text-gray-500"
                                :class="(passwordErrors.two_repetitions === -1) ? 'bg-red-100 text-red-500'
                                : (passwordErrors.two_repetitions === 1) ? 'bg-green-100 text-green-600' : ''"
                            >
                                <em
                                    class="fas fa-ban"
                                    :class="(passwordErrors.two_repetitions === -1) ? 'fas fa-times'
                                    : (passwordErrors.two_repetitions === 1) ? 'fas fa-check' : ''"
                                ></em> Não deve conter mais de 3 números repetidos.
                            </div>
                            <div
                                class="rounded-full py-2 px-4 text-sm bg-gray-100 text-gray-500"
                                :class="(passwordErrors.only_numbers === -1) ? 'bg-red-100 text-red-500'
                                : (passwordErrors.only_numbers === 1) ? 'bg-green-100 text-green-600' : ''"
                            >
                                <em
                                    class="fas fa-ban"
                                    :class="(passwordErrors.only_numbers === -1) ? 'fas fa-times'
                                    : (passwordErrors.only_numbers === 1) ? 'fas fa-check' : ''"
                                ></em> Deve conter apenas números.
                            </div>
                            <div
                                class="rounded-full py-2 px-4 text-sm bg-gray-100 text-gray-500"
                                :class="(passwordErrors.avoid_birthdate === -1) ? 'bg-red-100 text-red-500'
                                : (passwordErrors.avoid_birthdate === 1) ? 'bg-green-100 text-green-600' : ''"
                            >
                                <em
                                    class="fas fa-ban"
                                    :class="(passwordErrors.avoid_birthdate === -1) ? 'fas fa-times'
                                    : (passwordErrors.avoid_birthdate === 1) ? 'fas fa-check' : ''"
                                ></em> Evitar o uso de data de nascimento.
                            </div>
                            <div
                                class="rounded-full py-2 px-4 text-sm bg-gray-100 text-gray-500"
                                :class="(passwordErrors.password_confirmation === -1) ? 'bg-red-100 text-red-500'
                                : (passwordErrors.password_confirmation === 1) ? 'bg-green-100 text-green-600' : ''"
                            >
                                <em
                                    class="fas fa-ban"
                                    :class="(passwordErrors.password_confirmation === -1) ? 'fas fa-times'
                                    : (passwordErrors.password_confirmation === 1) ? 'fas fa-check' : ''"
                                ></em> Campo Senha e Confirmar senha devem ser iguais.
                            </div>
                        </div>

                        <div class="text-center w-full col-span-2 self-end">
                            <jet-label for="amount" value="Código de autorização" class="text-center text-sm"/>
                            <jet-input
                                id="amount" class="mt-1 w-full block"
                                type="text" v-model="form.google_code"
                            />
                            <jet-input-error :message="form.error('google_code')" />

                        </div>
                    </div>

                    <div class="flex justify-between mt-4">
                         <button-cancel @click.native="returnToIndex">Cancelar</button-cancel>
                         <button-confirmation @click.native="submit">
                            Confirmar
                        </button-confirmation>
                    </div>
                </div>
            </div>
        </div>

    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout'
import Welcome from './../../Jetstream/Welcome'
import ptBR from 'vuejs-datepicker/dist/locale'
import Button from "../../Jetstream/Button";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import ButtonConfirmation from '../../Jetstream/ButtonConfirmation.vue';
import ButtonCancel from '../../Jetstream/ButtonCancel.vue';

export default {
    components: {
        Flash,
        Balance,
        Button,
        AppLayout,
        Welcome,
        JetLabel,
        JetInput,
        JetInputError,
        ButtonConfirmation,
        ButtonCancel
    },
    props: ['card', 'customer', 'errors', 'update'],
    data() {
        return {
            ptBR: ptBR,
            form: this.$inertia.form({
                _method: 'POST',
                card_uuid: this.card.uuid,
                card_status: this.card.status,
                old_password: null,
                password: null,
                password_confirmation: null,
                google_code: null
            }, {
                resetOnSuccess: false,
            }),
            passwordErrors: {
                four_digits: 0,
                two_repetitions: 0,
                only_numbers: 0,
                avoid_birthdate: 0,
                password_confirmation: 0,
            }
        }
    },
    methods: {
        validatePassword() {
            this.passwordErrors.four_digits = this.form.password.length === 4 ? 1 : -1;
            this.passwordErrors.two_repetitions = this.form.password.match(/(.)\1{1,}/g) ? -1 : 1;
            this.passwordErrors.only_numbers = this.form.password.match(/^[0-9]+$/) ? 1 : -1;

            const birth_date = this.customer.birth_date.split('T')[0].split('-').reverse().join('').replace(/\D/g, '');
            this.passwordErrors.avoid_birthdate = birth_date.includes(this.form.password) ? -1 : 1;

            this.passwordErrors.password_confirmation = this.form.password === this.form.password_confirmation ? 1 : -1;
        },
        maxSize(type) {
            if (this.form[type].length > 4) {
                this.form[type] = this.form[type].slice(0, 4)
            }
        },
        returnToIndex() {
            this.$inertia.get(this.route('card.index'));
        },
        submit() {
            if (Object.values(this.passwordErrors).includes(-1) || Object.values(this.passwordErrors).includes(0) ) {
                this.$toast.open({
                    message: 'Senha inválida, preencha os campos corretamente.',
                    type: 'warning',
                    duration: 5000,
                    position: 'top-right',
                    showCloseButtonOnHover: true
                });
                return;
            }
            if (this.update) {
                this.form.post(this.route('card.submit-password-update'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.processing = false
                    },
                    onError: () => {
                        this.form.processing = false
                    }
                });
            } else {
                this.form.post(this.route('card.submit-password-creation'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.processing = false
                    },
                    onError: () => {
                        this.form.processing = false
                    }
                });
            }
        },
        show: function () {
            this.$inertia.get(this.route('card.index', this.card.uuid));
            return true;
        },
    }
}
</script>
